<template>
  <v-card>
    <v-card-title primary-title>
      <span class="title font-weight-light" v-text="type"></span>
    </v-card-title>
    <v-card-text>
      <slot name="preview" />
    </v-card-text>
    <v-card-actions>
      <slot name="edition" />
      <v-btn
        absolute
        fab
        bottom
        left
        small
        color="warning"
        @click="$emit('delete')"
      >
        <v-icon v-text="fa('trash-alt')"></v-icon>
      </v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>
export default {
  name: "WidgetWrapper",
  props: {
    type: {
      type: String,
      required: true
    }
  }
};
</script>
